// @flow
import { CHANGE_PAYMENT_TYPE_REQUEST } from "./actionTypes";

export default (stripeId) => ({
  type: CHANGE_PAYMENT_TYPE_REQUEST,
  payload: {
    stripeId
  }
});